import React from "react";
import { useParams } from "react-router";
import ResponseDetails from "./ResponseDetails";

const FillFormDetails = () => {
  const { id } = useParams();
  return <ResponseDetails key={id} id={id} />;
};

export default FillFormDetails;
